export const priceStyle = { fontSize: "inherit", fontWeight: "bold", color: "gray.500" };
export const discountStyle = { fontSize: "inherit", fontWeight: "bold", color: "red.100" };
export const priceBlockStyle = {
    ...priceStyle,
    flexWrap: "wrap",
    gap: 1,
    alignItems: "center",
};
